import React, { useContext } from 'react';

import { PhoneNumberInput as PhoneNumberInputComponent } from '../../../../components/ui/Inputs/PhoneNumberInput';
import { useFieldErrorAnalytics } from '../../../SignUp/useFieldErrorAnalytics';
import { MlifeAccountSetupContext } from '../MlifeAccountSetupContext';

export function PhoneNumberInput() {
  const { phoneNumberData, bindPhoneNumber, isLoading, invalidFields, creditAccount } =
    useContext(MlifeAccountSetupContext);
  useFieldErrorAnalytics({ field: 'phoneNumber', invalidFields });

  return (
    <PhoneNumberInputComponent
      name='phoneNumber'
      invalidFields={invalidFields}
      disabled={isLoading || !!(phoneNumberData && creditAccount)}
      {...bindPhoneNumber}
    />
  );
}
